import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from "../../../api/Api";

import computerImg from "../../../assets/computer.png";
import keyboardImg from '../../../assets/keyboard.png';
import mouseImg from '../../../assets/mouse.png';
import headsetImg from '../../../assets/headset.png';
import usbconnectorImg from '../../../assets/usbconnector.png';
import bagImg from '../../../assets/bag.png';
import laptopImg from '../../../assets/laptop.png';
import monitorImg from '../../../assets/monitor.png';
import chargerImg from "../../../assets/charger.png";
import cablesImg from "../../../assets/cables.png";
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import othersImg from '../../../assets/others.png'
import AssetImage from '../../../components/ImageUpload/AssetImage';

const imageMap = {
  laptop: laptopImg,
  desktop: computerImg,
  keyboard: keyboardImg,
  mouse: mouseImg,
  headset: headsetImg,
  usbconnector: usbconnectorImg,
  bag: bagImg,
  monitor: monitorImg,
  charger: chargerImg,
  cables: cablesImg,  
  others : othersImg,
};

function AllAsset() {
  const [assets, setAssets] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setpageSize] = useState(6);
  const [sortField, setSortField] = useState("typeName");
  const [sortOrder, setSortOrder] = useState("desc");

  const fetchAssetTypes = (page) =>{
    api
      .post("/api/assets/summary", {
        search: search && search.trim() !== "" ? search : null
      }, { 
        params: {
          page,
          size: pageSize,
          sort: `${sortField},${sortOrder}`,
        },
      })
      .then((res) => {
        setAssets(res.data.response.content);
        setTotalPages(res.data.response.totalPages);

      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    fetchAssetTypes(page);
  }, [page, sortField, sortOrder]);

  const handlePageChange = (event, value) => {
    setPage(value - 1);
  };

   useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setPage(0); 
      fetchAssetTypes(0);
    }, 100); 
    return () => clearTimeout(delayDebounce);
  }, [search]);


  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };




  return (
    <div className="container-fluid"
      style={{
        borderRadius: "20px",
        height:'100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}>

      <div className="d-flex justify-content-between align-items-center flex-wrap mb-1">
        <h2 className="mb-1">All Assets</h2>
        <input
          className="form-control rounded-pill p-3 mt-3 mb-3"
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by asset type..."
          style={{ width: '60%', fontSize: '15px' }}
        />
        <Link to="/assets/add" className="btn btn-primary mt-3 mb-3">
          + Add Asset
        </Link>

        <Link to="/asset-types" className="btn btn-primary mt-3 mb-3">
          + Add Asset Type
        </Link>
      </div>


      <div className="row" style={{ overflowY: 'auto', flex: 1, paddingRight: '10px' }}>
        {assets.length > 0 ? (
          assets.map(asset => {
            // const imgSrc = imageMap[asset.assetType.toLowerCase()];
            return (
              <div className="col-lg-4" key={asset.assetType}>
                <div className="card border shadow-sm p-3"
                //  style={{width:'400px',marginLeft:"15px"}}
                 >

                  <h5 className="card-title text-capitalize">
                    {asset.assetType} <span className="text-muted">({asset.total})</span>
                  </h5>


                  <div className="d-flex">

                    <div className="me-3 d-flex align-items-center">
                      <AssetImage
                        imagePath={asset.imagePath}
                        width={80}
                        height={80}
                      />
                    </div>


                    <div className="vr mx-2" />


                    <div className="card-body p-0">
                      <div className="d-flex flex-column text-dark small">
                        <div className="d-flex justify-content-between">
                          <span>Assigned</span>
                          <span>{asset.assigned}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>Unassigned</span>
                          <span>{asset.unAssigned}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>Issue</span>
                          <span>{asset.issue}</span>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="d-flex justify-content-center mt-2">
                    <Link
                      to={`/assets/type/${asset.identy}`}
                      className="custom-btn w-75 rounded-pill"
                    >
                      View Assets
                    </Link>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="col-12 text-center mt-5">
            <p className="text-muted">No matching asset types found.</p>
          </div>
        )}
      </div>



      {/* MUI Pagination */}
      <div className="d-flex justify-content-center mt-2 mb-1">
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={page + 1}  // convert 0-based -> 1-based
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            variant="outlined"
          />
        </Stack>
      </div>


    </div>
  );
}

export default AllAsset;  
